<template>
  <div class="tool-bar-components">
    <div class="tool-bar">
      <div v-if="from == 'order'" class="tool-select">
        <el-select v-model="value" clearable placeholder="筛选运单状态" @change="select">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div v-if="from == 'order'" class="tool-select">
        <el-select v-model="directionValue" clearable placeholder="筛选流向" @change="directionSelect">
          <el-option
              v-for="item in directionOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div v-if="from == 'order'" class="tool-select">
        <el-date-picker
            v-model="date"
            end-placeholder="结束日期"
            range-separator="至"
            start-placeholder="开始日期"
            type="daterange"
            value-format="yyyy-MM-dd"
            @change="chooseTime">
        </el-date-picker>
      </div>
      <div v-if="from == 'order'" class="tool-select">
        <el-select v-model="packageId" clearable filterable placeholder="货柜筛选" @change="selectPackage">
          <el-option
              v-for="item in package"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div v-if="useSearch" class="tool-bar-search">
        <el-input
            v-model="searchValue"
            :placeholder="searchPlaceholder"
            class="search-input"
            clearable
            prefix-icon="el-icon-search"
            @clear="searchClear">
        </el-input>
        <el-button circle icon="el-icon-search" @click="searchClick()"></el-button>
      </div>
      <div v-if="add" class="tool-bar-search" style="margin-left: 25px">
        <el-button type="text" @click="open()">新增货柜</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    add: {
      type: Boolean,
      default: false
    },
    useSearch: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: '搜索'
    },
    from: {
      type: String,
      default: 'none'
    },
    package: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      date: '',
      searchValue: '',
      packageId: '',
      options: [{
        value: 'all',
        label: '全部'
      }, {
        value: '-1',
        label: '已取消'
      }, {
        value: '0',
        label: '待收件'
      }, {
        value: '1',
        label: '待打包'
      }, {
        value: '2',
        label: '待支付'
      }, {
        value: '3',
        label: '待出库'
      },
        {
          value: '4',
          label: '运输中'
        },
        {
          value: '5',
          label: '转投成功'
        },
        {
          value: '6',
          label: '派件'
        },
        {
          value: '7',
          label: '妥投'
        }],
      directionOptions: [{
        value: '65',
        label: '新加坡至中国'
      }, {
        value: '86',
        label: '中国至新加坡'
      }],
      value: '',
      directionValue: ''
    }
  },
  methods: {
    open() {
      this.$emit('open', this.open);
    },
    searchClick() {
      this.$emit('search', this.searchValue);
    },

    searchClear() {
      this.$emit('clear');
    },
    select() {
      this.$emit('select', this.value);
    },
    directionSelect() {
      this.$emit('directionSelect', this.directionValue || '');
    },
    chooseTime() {
      this.$emit('chooseTime', this.date);
    },
    selectPackage() {
      this.$emit('selectPackage', this.packageId);
    }
  }
}
</script>

<style scoped>
.tool-bar {
  display: flex;
  width: 100%;
  align-items: center;
}

.tool-bar-components {
  background-color: #FFFFFF;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
  padding-bottom: 10px;

}

.tool-bar-search {
  display: flex;
  width: 300px;
  flex: 0 0 300px;
}

.search-input {
  margin-right: 10px;
}

.tool-select {
  margin-right: 20px;
}
</style>
